export enum Gender{
    Male,
    Female,
}



// WEBPACK FOOTER //
// ./src/State/Gender.ts